<template>
  <div>
    <h2>
      EDI Configuration
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
    >
      <el-form-item label="Account Number Required">
        <el-switch v-model="formData.edi_acc_req" />
      </el-form-item>
      <el-form-item label="Accepts RTP (Receiver / Third Party)">
        <el-switch v-model="formData.edi_accepts_rtp" />
      </el-form-item>
      <el-form-item label="Site ID Required">
        <el-switch v-model="formData.edi_siteid_req" />
      </el-form-item>
      <el-form-item label="Sys ID Required">
        <el-switch v-model="formData.edi_sysid_req" />
      </el-form-item>
      <el-form-item label="Send EDI">
        <el-switch v-model="formData.transfer_type" />
      </el-form-item>
      <el-form-item label="EDI Template (Legacy)">
        <el-input v-model="formData.edi_template" />
      </el-form-item>
      <el-form-item label="EDI Transformation Template">
        <el-input v-model="formData.edi_transformer_template" />
      </el-form-item>
      <el-form-item label="EDI Exporter Template">
        <el-input v-model="formData.edi_exporter_template" />
      </el-form-item>
      <el-form-item label="S/FTP Connection">
        <el-select
          v-model="formData.edi_connection"
          :loading="loading"
          filterable
          value-key="long"
          class="w-100"
        >
          <el-option
            v-for="item in connections"
            :key="item.id"
            :label="getConnectionName(item)"
            :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      loading: true,
      connections: []
    }
  },
  created () {
    this
      .$sdk
      .connection
      .list(request => {
        request.limit = 500
      })
      .then(connections => { this.connections = connections })
      .finally(() => {
        this.loading = false
        this.connections.forEach(element => {
          console.log(element.id)
        })
      })
  },
  methods: {
    getConnectionName (connection) {
      return `${connection.display_name} (${connection.username}@${connection.host})`
    }
  }
}
</script>
